/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpScreen } from 'apps/console-core/src/Components/DxpScreen/DxpScreen';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPONENT_SERVICE_STRINGS } from '../../Constants/Strings.constants';
import { ContentMatrixIdentifierList } from './elements/ContentMatrixIdentifierList/ContentMatrixIdentifierList';
import { CreateContentMatrixIdentifier } from './elements/CreateContentMatrixIdentifier/CreateContentMatrixIdentifier';

/**
 * The screen for managing content matrix identifiers.
 * @export
 * @returns {JSX.Element} The `<ContentMatrixIdentifiers />` component.
 */
export const ContentMatrixIdentifiers = (): JSX.Element => {
  const { t } = useTranslation();

  const sectionContent = (
    <>
      <CreateContentMatrixIdentifier />
      <ContentMatrixIdentifierList />
    </>
  );

  return <DxpScreen heading={t(COMPONENT_SERVICE_STRINGS.matrixApiIdentifiers)}>{sectionContent}</DxpScreen>;
};
